
define('modules/application/wizard/steps/zoneStep/separatorMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi"
],

function(
  app,
  Backbone,
  jQueryUi) {

  var separatorMenuView = Backbone.View.extend({
    template  :  "application/wizard/steps/zones/separator-item",
    className :  "zone separator",
    tagName   :  "li",
    serialize : function() {return {name : this.name};}
  });

  //Creating final complexZoneStep class
  separatorMenuView.extend({
    objClass      : "separatorMenuView"
  });

  // Required, return the module for AMD compliance
  return separatorMenuView;

});